import * as React from 'react';
import { useContext } from 'react';
import { ConfigContext } from 'modules/context';
import { WIDGET_NAME } from '@sitegen/common/constants';

import BaseScreen from '../../modules/base-screen';
import RedemptionSuccess from '../redemption/redemption-success';
import RedemptionSuccessV2 from '../redemption/v2/redemption-success';
import PYCSuccess from '../pyc-redeem/success';

const SuccessWrapper: React.FC = () => {
    const { config: { widgetName } } = useContext(ConfigContext);
    switch (widgetName as WIDGET_NAME) {
    case WIDGET_NAME.CF_REDEEM_V2: return <RedemptionSuccessV2 />;
    case WIDGET_NAME.PYC_REDEEM: return <BaseScreen><PYCSuccess /></BaseScreen>;
    default: return <RedemptionSuccess />;
    }
};

export default SuccessWrapper;
